import React from "react";
import { Link } from "react-router-dom";
import { Wrench, Search, MapPin, ShieldCheck, ChevronDown } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export function AboutPage() {
  const s = useSettings();
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-12">
      <div className="text-center mb-10">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[var(--amber)] text-[#0B0F17] mb-4"><Wrench size={30} /></span>
        <h1 className="font-head text-3xl sm:text-4xl font-black text-white">من نحن</h1>
      </div>
      <div className="ts-card p-6 sm:p-9 space-y-4 text-[var(--text-muted)] leading-relaxed">
        <p><span className="text-white font-bold">{s.platform_name}</span> منصة رقمية سعودية تهدف إلى جمع التشاليح وقطع غيار السيارات المستعملة في منصة واحدة، وتسهيل وصول العميل إلى القطعة التي يبحث عنها بدلًا من زيارة عدة تشاليح والبحث يدويًا.</p>
        <p>يستطيع العميل البحث عن القطعة ومقارنة الأسعار والحالة بين التشاليح، والتواصل مع البائع وطلب القطعة بسهولة، مع خيار الدفع عند الاستلام.</p>
        <p>نبدأ من مدينة جدة مع إمكانية التوسّع مستقبلًا إلى مناطق أخرى في المملكة. ولا ندّعي تغطية جميع التشاليح في السعودية حاليًا.</p>
        <div className="grid sm:grid-cols-3 gap-4 pt-4">
          {[["ابحث بسهولة", Search], ["تشاليح موثقة", ShieldCheck], ["الأقرب إليك", MapPin]].map(([t, Icon]) => (
            <div key={t} className="rounded-xl bg-[var(--bg-secondary)] p-4 text-center">
              <Icon className="mx-auto text-[var(--amber)] mb-2" size={24} />
              <p className="text-sm font-bold text-white">{t}</p>
            </div>
          ))}
        </div>
        <div className="pt-4 text-sm">
          <p>{s.platform_name} · العنوان: {s.address}</p>
          <p>دعم واتساب: {s.support_whatsapp}</p>
        </div>
      </div>
    </div>
  );
}

const FAQS = [
  ["كيف أبحث عن قطعة؟", "اكتب اسم القطعة أو رقمها أو اختر سيارتك وسنة الصنع، ثم فلتر النتائج حسب المدينة والسعر والأقرب إليك."],
  ["كيف أطلب قطعة؟", "من صفحة القطعة اضغط «اطلب القطعة»، اختر الكمية وطريقة الاستلام، وأكّد الطلب. طريقة الدفع الحالية هي الدفع عند الاستلام."],
  ["هل تأخذ المنصة عمولة؟", "لا، قيمة بيع القطعة كاملة تعود للتشليح ولا تأخذ المنصة أي نسبة من البيع."],
  ["كيف أطلب استرجاعًا أو استبدالًا؟", "افتح الطلب من «طلباتي» واضغط «طلب استرجاع / استبدال»، اختر السبب وأرفق صورًا أو فيديو وأرسل الطلب لتتابع حالته."],
  ["ما الفرق بين تواصل مع التشليح ودعم واتساب؟", "«تواصل مع التشليح» يوصلك بالبائع مباشرة عبر رقمه، أما «دعم واتساب» فيوصلك بإدارة المنصة على الرقم الرسمي."],
  ["كيف أسجّل مخزون كار؟", "اضغط «انضم كتشليح» وأدخل بيانات منشأتك ورقم سجلك التجاري الخاص بك؛ بعد مراجعة الإدارة يتم توثيق حسابك."],
];

export function FAQPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-12">
      <h1 className="font-head text-3xl font-black text-white text-center mb-8">الأسئلة الشائعة</h1>
      <div className="space-y-3">
        {FAQS.map(([q, a], i) => (
          <details key={i} data-testid={`faq-${i}`} className="ts-card p-5 group">
            <summary className="flex items-center justify-between cursor-pointer list-none font-bold text-white">
              {q}<ChevronDown size={18} className="text-[var(--amber)] transition-transform group-open:rotate-180" />
            </summary>
            <p className="text-sm text-[var(--text-muted)] leading-relaxed mt-3">{a}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
